var _rect, _rect2, _path, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    rx: 2,
    fill: "#5C7CAC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 5.5,
    width: 12,
    height: 10,
    rx: 1.5,
    fill: "white",
    stroke: "#5C7CAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.059 9.206C28.877 9.01 28.6997 8.87933 28.527 8.814C28.359 8.74867 28.1887 8.716 28.016 8.716C27.7593 8.716 27.526 8.76267 27.316 8.856C27.1107 8.94467 26.9333 9.07067 26.784 9.234C26.6347 9.39267 26.518 9.57933 26.434 9.794C26.3547 10.0087 26.315 10.2397 26.315 10.487C26.315 10.753 26.3547 10.998 26.434 11.222C26.518 11.446 26.6347 11.6397 26.784 11.803C26.9333 11.9663 27.1107 12.0947 27.316 12.188C27.526 12.2813 27.7593 12.328 28.016 12.328C28.2167 12.328 28.4103 12.2813 28.597 12.188C28.7883 12.09 28.9657 11.936 29.129 11.726L29.857 12.244C29.633 12.552 29.36 12.776 29.038 12.916C28.716 13.056 28.373 13.126 28.009 13.126C27.6263 13.126 27.274 13.0653 26.952 12.944C26.6347 12.818 26.3593 12.643 26.126 12.419C25.8973 12.1903 25.7177 11.9173 25.587 11.6C25.4563 11.2827 25.391 10.9303 25.391 10.543C25.391 10.1463 25.4563 9.787 25.587 9.465C25.7177 9.13833 25.8973 8.86067 26.126 8.632C26.3593 8.40333 26.6347 8.22833 26.952 8.107C27.274 7.981 27.6263 7.918 28.009 7.918C28.345 7.918 28.6553 7.97867 28.94 8.1C29.2293 8.21667 29.4977 8.41733 29.745 8.702L29.059 9.206Z",
    fill: "#5C7CAC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 20.5,
    x2: 23,
    y2: 20.5,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 16.5,
    x2: 16,
    y2: 16.5,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 24.5,
    x2: 23,
    y2: 24.5,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.05045cb276b6b6f0fb4d50dd4ad139aa.svg";
export { ForwardRef as ReactComponent };